import React, { Component } from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import Reveal from "react-reveal/Zoom"
import RevealBounce from "react-reveal/Bounce"
import Layout from "../layouts/default"
import SEO from "../components/seo"
import { Col, Container, Row } from "react-bootstrap"
import "./solution.scss"
import { hexaToDark, hexaToRgba } from "../components/functions"
import Buttons from "../components/paragraph/buttons"
import Form from "../components/paragraph/form"
import Image from "../components/paragraph/image"
import Heading from "../components/paragraph/heading"
import Html from "../components/paragraph/html"
import Paragraph from "../components/paragraph/paragraphs"

class SolutionTemplate extends Component {
  render() {
    const solution = this.props.data.allNodeSolution.edges[0].node
    const header = solution.relationships.field_header
      ? solution.relationships.field_header.relationships
      : undefined
    const textbox_s = solution.relationships.field_textbox_s
      ? solution.relationships.field_textbox_s.relationships.field_textbox_s
      : undefined
    const image_s_heading = solution.relationships.field_image_s_heading
      ? solution.relationships.field_image_s_heading
      : undefined
    const field_video_section = solution.relationships.field_video
      ? solution.relationships.field_video.relationships.field_video_section
      : undefined
    const field_features = solution.relationships.field_features
      ? solution.relationships.field_features.relationships.field_image_s_text
      : undefined
    const field_inline_cta = solution.relationships.field_inline_cta
      ? solution.relationships.field_inline_cta.relationships.field_inline_cta
      : undefined
    const field_industries = solution.relationships.field_industries
      ? solution.relationships.field_industries
      : undefined
    const field_form_learn_more = solution.relationships.field_form_learn_more
      ? solution.relationships.field_form_learn_more
      : undefined

    return (
      <Layout>
        <SEO title={solution.title}/>

        {/* HEADER
         */}
        {header && (
          <section
            id="header"
            className={"text-left"}
            style={{ padding: 0, position: "relative" }}
          >
            {/* <Container style={{padding: "0 15px"}}>
							<p style={{position: "absolute", top: 0}}>Breadcrumb</p>
						</Container> */}
            <Container
              fluid={true}
              style={{
                paddingTop: 0,
                paddingBottom: 0,
                position: "absolute",
                top: 0,
              }}
            >
              <Row className={"justify-content-end"}>
                <Col
                  xs={12}
                  md={6}
                  className={`d-none d-md-block`}
                  style={{ padding: 0, height: "500px" }}
                >
                  <GatsbyImage
                    image={header.field_image.relationships.field_media_image
                      .localFile.childImageSharp.gatsbyImageData}
                    imgStyle={{ objectFit: "cover" }}
                    alt={header.field_image.field_media_image.alt}
                    style={{ height: "100%" }} />
                </Col>
              </Row>
            </Container>
            <Container fluid={true} style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Row
                className={"justify-content-start"}
                style={{ height: "500px" }}
              >
                <Col xs={12} md={6} className={"mt-auto mb-auto"} style={{}}>
                  <div style={{ maxWidth: "500px", margin: "auto" }}>
                    {header.field_caption &&
                    header.field_caption.map((elem, index) => {
                      let type
                      try {
                        type = elem.internal.type
                      } catch (e) {
                      }
                      switch (type) {
                        case "paragraph__component_button_s":
                          return <Buttons props={elem} key={index}/>
                        case "paragraph__component_heading":
                          return (
                            <Heading
                              props={elem}
                              type={elem.field_heading_type}
                              key={index}
                            />
                          )
                        case "paragraph__component_image":
                          return <Image props={elem} key={index}/>
                        case "paragraph__component_paragraph_s":
                          return <Paragraph props={elem} key={index}/>
                        default:
                          return (
                            <p
                              key={index}
                              style={{
                                color: "red",
                                fontWeight: "bold",
                                background: "white",
                              }}
                            >
                              Failed to load component!
                            </p>
                          )
                      }
                    })}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        )}

        {/* LEADING TEXT BOXES
         */}
        {textbox_s &&
        textbox_s.map((elem, index) => {
          return (
            <section
              id="textbox_s"
              key={index}
              className={`text-left ${
                elem.field_background_color &&
                hexaToDark(elem.field_background_color)
                  ? "dark"
                  : ""
              }`}
              style={{
                backgroundColor: hexaToRgba(elem.field_background_color),
              }}
            >
              <Container>
                {/* <Reveal> */}
                <Row>
                  <Col>
                    <Html props={elem.field_html}/>
                  </Col>
                </Row>
                {/* </Reveal> */}
              </Container>
            </section>
          )
        })}

        {/* ICONS + HEADINGS
         */}
        {image_s_heading && (
          <section
            id="image_s_heading"
            className={`${
              image_s_heading.field_background_color &&
              hexaToDark(image_s_heading.field_background_color)
                ? "dark"
                : ""
            }`}
            style={{
              backgroundColor: hexaToRgba(
                image_s_heading.field_background_color,
              ),
            }}
          >
            <Container>
              {/* <Reveal> */}
              <Row>
                {image_s_heading.relationships.field_image_heading.map(
                  (elem, index) => {
                    return (
                      <Col xs={6} md={3} key={index}>
                        <Reveal duration={800 + index * 400}>
                          <img
                            src={
                              elem.relationships.field_image.relationships
                                .field_media_image.localFile.publicURL
                            }
                            alt={elem.relationships.field_image.alt}
                            style={{
                              maxWidth: "64px",
                              height: "64px",
                              margin: 0,
                            }}
                          />
                          <h4 style={{ color: "black" }}>
                            {elem.field_heading}
                          </h4>
                        </Reveal>
                      </Col>
                    )
                  },
                )}
              </Row>
              {/* </Reveal> */}
            </Container>
          </section>
        )}

        {/* VIDEO
         */}
        {field_video_section && (
          <section
            id="field_video_section"
            className={`${
              field_video_section.field_background_color &&
              hexaToDark(field_video_section.field_background_color)
                ? "dark"
                : ""
            }`}
            style={{
              backgroundColor: hexaToRgba(
                field_video_section.field_background_color,
              ),
              position: "relative",
            }}
          >
            {field_video_section.relationships &&
            field_video_section.relationships.field_background_image && (
              <GatsbyImage
                image={{
                  ...field_video_section.relationships.field_background_image
                    .relationships.field_media_image.localFile.childImageSharp.gatsbyImageData,
                }}
                imgStyle={{ objectFit: "cover" }}
                style={{}}
                className={"cover-xy"} />
            )}
            {field_video_section.field_background_color && (
              <div
                className={"cover-xy"}
                style={{
                  backgroundColor: `${
                    field_video_section.field_background_color
                      ? hexaToRgba(field_video_section.field_background_color)
                      : "initial"
                  }`,
                }}
              />
            )}
            <Container>
              {/* <Reveal> */}
              <Row className={"justify-content-center"}>
                <Col xs={12}>
                  <h2>{field_video_section.field_heading}</h2>
                  {field_video_section.relationships.field_paragraph_s.map(
                    (elem, index) => {
                      return <p key={index}>{elem.field_paragraph}</p>
                    },
                  )}
                </Col>
                <Col xs={12} md={8} lg={6}>
                  <iframe
                    title="video"
                    width="100%"
                    height="300"
                    src={`https://www.youtube-nocookie.com/embed/${
                      field_video_section.relationships.field_video.field_youtube.split(
                        "watch?v=",
                      )[1]
                    }`}
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture;"
                    allowFullScreen
                    style={{ margin: 0 }}
                  />
                </Col>
              </Row>
              {/* </Reveal> */}
            </Container>
          </section>
        )}

        {/* FEATURES
         */}
        {field_features && (
          <section id="field_features" style={{ padding: 0 }}>
            <Container fluid={true}>
              <Row>
                {/* <Reveal> */}
                {field_features.map((elem, index) => {
                  return (
                    <Row key={index} noGutters={true} style={{ width: "100%" }}>
                      <Col
                        md={{ span: 6, order: index % 2 === 0 ? 1 : 12 }}
                        className={"text-left m-auto"}
                        style={{}}
                      >
                        <Col md={{ span: 8, offset: 2 }}>
                          <Html props={elem.field_html}/>
                        </Col>
                      </Col>
                      <Col
                        md={{ span: 6, order: index % 2 === 0 ? 12 : 1 }}
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        <GatsbyImage
                          image={elem.relationships.field_image.relationships
                            .field_media_image.localFile.childImageSharp.gatsbyImageData}
                          imgStyle={{ objectFit: "cover" }}
                          alt={
                            elem.relationships.field_image.field_media_image.alt
                          }
                          style={{}} />
                      </Col>
                    </Row>
                  );
                })}
                {/* </Reveal> */}
              </Row>
            </Container>
          </section>
        )}

        {/* INLINE CALL TO ACTION
         */}
        {field_inline_cta && (
          <section
            id="field_inline_cta"
            className={`text-left ${
              field_inline_cta.field_background_color &&
              hexaToDark(field_inline_cta.field_background_color)
                ? "dark"
                : ""
            }`}
            style={{
              backgroundColor: hexaToRgba(
                field_inline_cta.field_background_color,
              ),
              position: "relative",
            }}
          >
            <RevealBounce left duration={1200}>
              <Container>
                <Row className={"justify-content-center"}>
                  <Col xs={12} md={8}>
                    <Html props={field_inline_cta.field_html}/>
                  </Col>
                  <div className={"d-flex"}>
                    <span className={"m-auto"}>
                      <Buttons props={field_inline_cta} className={"m-auto"}/>
                    </span>
                  </div>
                </Row>
              </Container>
            </RevealBounce>
          </section>
        )}

        {/* INDUSTRIES
         */}
        {field_industries && (
          <section
            id="field_industries"
            className={`${
              field_industries.field_background_color &&
              hexaToDark(field_industries.field_background_color)
                ? "dark"
                : ""
            }`}
            style={{
              backgroundColor: hexaToRgba(
                field_industries.field_background_color,
              ),
              position: "relative",
            }}
          >
            {field_industries.relationships &&
            field_industries.relationships.field_background_image && (
              <GatsbyImage
                image={{
                  ...field_industries.relationships.field_background_image
                    .relationships.field_media_image.localFile.childImageSharp.gatsbyImageData,
                }}
                imgStyle={{ objectFit: "cover" }}
                style={{}}
                className={"cover-xy"} />
            )}
            {field_industries.field_background_color && (
              <div
                className={"cover-xy"}
                style={{
                  backgroundColor: `${
                    field_industries.field_background_color
                      ? hexaToRgba(field_industries.field_background_color)
                      : "initial"
                  }`,
                }}
              />
            )}
            <Container>
              <Row className={"justify-content-center"}>
                <Col xs={12}>
                  <h2>{field_industries.field_heading}</h2>
                </Col>
                {field_industries.relationships.field_image_s_text_link.map(
                  (elem, index) => {
                    return (
                      <Col
                        xs={12}
                        lg={4}
                        className={"hover-bg text-left"}
                        style={{ padding: "25px" }}
                        key={index}
                      >
                        <Image props={elem}/>
                        <Html props={elem.field_html}/>
                        {elem.field_link && (
                          <p>
                            <Link
                              to={elem.field_link.uri}
                              style={{ textTransform: "uppercase" }}
                            >
                              {elem.field_link.title}
                            </Link>
                          </p>
                        )}
                      </Col>
                    )
                  },
                )}
              </Row>
            </Container>
          </section>
        )}

        {/* FORM + CTA
         */}
        {field_form_learn_more && (
          // <section id="field_form_learn_more"
          // 	className={"text-left"} style={{padding: 0}}>
          // 	<Container fluid={true}>
          // {/* <Reveal> */}
          // <Row className={"justify-content-center"}>
          // 	<Col style={{backgroundColor: "#d7dee3"}} xs={12} md={6}>
          // 		<Row className={"justify-content-end"} style={{height: "100%"}}>
          // 			<Col className={""} style={{padding: "30px", maxWidth: "550px"}}>
          // 				<Html props={field_form_learn_more.field_html}/>
          // 				<Form props={field_form_learn_more.relationships.field_form}/>
          // 			</Col>
          // 		</Row>
          // 	</Col>
          // 	<Col xs={12} md={6}>
          // 		<Row style={{height: "100%"}}>
          // 			<Col className={""} style={{padding: "45px 30px", maxWidth: "500px"}}>
          // 				{field_form_learn_more.relationships && field_form_learn_more.relationships.field_image && <Image style={{width: "200px", marginBottom: "15px", }} props={field_form_learn_more}/>}
          // 				<Html props={field_form_learn_more.field_html_2}/>
          // 				{field_form_learn_more.field_link &&
          // 					<Buttons props={field_form_learn_more} className={"btn btn-secondary"}>{field_form_learn_more.field_link.title}</Buttons>
          // 					// <p><Link to={field_form_learn_more.field_link.uri} className={"btn btn-secondary"}>{field_form_learn_more.field_link.title}</Link></p>
          // 				}
          // 			</Col>
          // 		</Row>
          // 	</Col>
          // </Row>
          // {/* </Reveal> */}
          // 	</Container>
          // </section>

          <section
            id="field_form_learn_more"
            className={"text-left"}
            style={{ padding: 0 }}
          >
            <Container fluid={true}>
              <Row>
                <Col
                  xs={12}
                  md={6}
                  style={{
                    backgroundColor: "#d7dee3",
                    paddingTop: "30px",
                    paddingBottom: "30px",
                  }}
                >
                  <Row
                    className={
                      "h-100 justify-content-center justify-content-xl-end"
                    }
                  >
                    <Container
                      className={"half-container-xl"}
                      style={{ paddingLeft: "30px", paddingRight: "30px" }}
                    >
                      <Row>
                        {/* <Reveal> */}
                        <Col>
                          <Html props={field_form_learn_more.field_html}/>
                          <Form
                            props={
                              field_form_learn_more.relationships.field_form
                            }
                          />
                        </Col>
                        {/* </Reveal> */}
                      </Row>
                    </Container>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  style={{
                    paddingTop: "30px",
                    paddingBottom: "30px",
                  }}
                >
                  <Row
                    className={
                      "h-100 justify-content-center justify-content-xl-start"
                    }
                  >
                    <Container
                      className={"half-container-xl"}
                      style={{ paddingLeft: "30px", paddingRight: "30px" }}
                    >
                      <Row>
                        {/* <Reveal> */}
                        <Col>
                          {field_form_learn_more.relationships &&
                          field_form_learn_more.relationships.field_image && (
                            <Image
                              style={{ width: "200px", marginBottom: "15px" }}
                              props={field_form_learn_more}
                            />
                          )}
                          <Html props={field_form_learn_more.field_html_2}/>
                          {field_form_learn_more.field_link && (
                            <Buttons
                              props={field_form_learn_more}
                              className={"btn btn-secondary"}
                            >
                              {field_form_learn_more.field_link.title}
                            </Buttons>
                          )}
                        </Col>
                        {/* </Reveal> */}
                      </Row>
                    </Container>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        )}
      </Layout>
    );
  }
}

export default SolutionTemplate

export const query = graphql`query ($id: String!) {
  allNodeSolution(filter: {id: {eq: $id}}) {
    edges {
      node {
        title
        field_summary
        relationships {
          field_header {
            relationships {
              field_image {
                field_media_image {
                  alt
                }
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                      }
                      publicURL
                    }
                  }
                }
              }
              field_caption {
                ... on paragraph__component_button_s {
                  internal {
                    type
                  }
                  relationships {
                    field_button_s {
                      field_link {
                        title
                        uri
                      }
                    }
                  }
                }
                ... on paragraph__component_heading {
                  internal {
                    type
                  }
                  field_heading
                  field_heading_type
                }
                ... on paragraph__component_image {
                  internal {
                    type
                  }
                  relationships {
                    field_image {
                      field_media_image {
                        alt
                      }
                      relationships {
                        field_media_image {
                          localFile {
                            childImageSharp {
                              gatsbyImageData(layout: FULL_WIDTH)
                            }
                            publicURL
                          }
                        }
                      }
                    }
                  }
                }
                ... on paragraph__component_paragraph_s {
                  internal {
                    type
                  }
                  relationships {
                    field_paragraph_s {
                      field_paragraph
                    }
                  }
                }
              }
            }
          }
          field_textbox_s {
            relationships {
              field_textbox_s {
                field_background_color {
                  color
                  opacity
                }
                field_html {
                  processed
                  value
                }
              }
            }
          }
          field_image_s_heading {
            field_background_color {
              color
              opacity
            }
            relationships {
              field_image_heading {
                field_heading
                relationships {
                  field_image {
                    field_media_image {
                      alt
                    }
                    relationships {
                      field_media_image {
                        localFile {
                          publicURL
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          field_features {
            relationships {
              field_image_s_text {
                field_html {
                  processed
                  value
                }
                relationships {
                  field_image {
                    field_media_image {
                      alt
                    }
                    relationships {
                      field_media_image {
                        localFile {
                          childImageSharp {
                            gatsbyImageData(layout: FULL_WIDTH)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          field_inline_cta {
            relationships {
              field_inline_cta {
                field_background_color {
                  color
                  opacity
                }
                field_html {
                  processed
                  value
                }
                relationships {
                  field_button_s {
                    field_link {
                      title
                      uri
                    }
                  }
                }
              }
            }
          }
          field_form_learn_more {
            field_html {
              processed
              value
            }
            relationships {
              field_form {
                field_form_id
                field_form_id_2
              }
              field_image {
                field_media_image {
                  alt
                }
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                      }
                      publicURL
                    }
                  }
                }
              }
            }
            field_html_2 {
              processed
              value
            }
            field_link {
              title
              uri
            }
          }
        }
      }
    }
  }
}
`

// field_industries {
// 	field_heading
// 	relationships {
// 		field_background_image {
// 			field_media_image {
// 				alt
// 			}
// 			relationships {
// 				field_media_image {
// 					localFile {
// 						childImageSharp {
// 							fluid {
// 								...GatsbyImageSharpFluid_withWebp
// 							}
// 						}
// 						publicURL
// 					}
// 				}
// 			}
// 		}
// 		field_image_s_text_link {
// 			relationships {
// 				field_image {
// 					field_media_image {
// 						alt
// 					}
// 					relationships {
// 						field_media_image {
// 							localFile {
// 								childImageSharp {
// 									fluid {
// 										...GatsbyImageSharpFluid_withWebp
// 									}
// 								}
// 								publicURL
// 							}
// 						}
// 					}
// 				}
// 			}
// 			field_html {
// 				processed
//        value
// 			}
// 			field_link {
// 				title
// 				uri
// 			}
// 		}
// 	}
// 	field_background_color {
// 		color
// 		opacity
// 	}
// }
